
import styled from "@emotion/styled";
import DarkPageBg from '../../../assets/img/dark-page-bg.png'
import LightPageBg from '../../../assets/img/light-page-bg.png'

export const introduce = 'introduce'
export const introduce_title = 'introduce_title'
export const introduce_desc = 'introduce_desc'
export const CustomPageWrapper = styled.div(({ theme: { designTokens: DT }, isApplyCustomLayout, isCustomLayoutBgLight, pathname }) => {
    const isLogin = pathname.includes("/login");
    if (!isApplyCustomLayout) return `
        .${introduce} {
            display: none;
        }
        height: 100%;
    `
    if (isLogin) return `
        position: relative;
        height: 100%;

        .${introduce} {
            position: absolute;
            top: 50%;
            left: 25%;
            transform: translate(-50%, -50%);
            z-index: 9;
        }
        .${introduce_title} {
            color: ${ isCustomLayoutBgLight ? DT.T_COLOR_TEXT_DEFAULT_DARK : DT.T_COLOR_TEXT_DEFAULT_BRIGHT};
            font-family: "PingFangSC-Semibold";
            font-size: 32px;
            font-weight: 600;
            font-style: Semibold;
            letter-spacing: 0px;
            text-align: center;
            margin-top: 0px;
            margin-bottom: 16px;
        }
        .${introduce_desc} {
            width: 430px;
            opacity: 0.7;
            color: ${ isCustomLayoutBgLight ? DT.T_COLOR_TEXT_DEFAULT_DARK : DT.T_COLOR_TEXT_DEFAULT_BRIGHT};
            font-family: "PingFangSC-Regular";
            font-size: 14px;
            font-weight: 400;
            font-style: Regular;
            letter-spacing: 0px;
            text-align: left;
            line-height: 21px;

        }
        .u-site-wrapper {
            background: transparent;
            min-height: auto;
            position: relative;
        }

        .u-site-wrapper::before {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            height: 100%;
            width: 50%;
            background: url(${DarkPageBg}) left center no-repeat;
            background-size: cover;
            z-index: -1;
        }

        .u-content .u-content-wrapper {
            position: absolute;
            left: 75%;
            top: 50%;
            transform: translate(-50%, -50%);
            z-index: 9;
        }
        .copyright {
            width: auto;
            left: 75%;
            transform: translateX(-50%);
        }
    `
    return `
        height: 100%;
        .${introduce} {
            display: none;
        }
        .u-site-wrapper {
            background: transparent;
            background: url(${LightPageBg}) left center no-repeat;
            background-size: 100% 100%;
        }

    `;
});



// WEBPACK FOOTER //
// ./src/common/custom-layout/CustomPageWrapper/style.jsx